import { Box } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router";

import { CustomButton } from "@/components/Button";
import { ErrorPanel } from "@/components/StatePanels";

interface DiagnosisInvestmentStyleResultErrorProps {
  onRetry: () => void;
}

// 404（未回答）以外の取得失敗（500・タイムアウト等）専用。404はフック側で自動的にイントロへ誘導するため
// ここには来ない。再試行に加え、詰まった場合の出口としてマイページへの導線も用意する。
export const DiagnosisInvestmentStyleResultError: React.FC<DiagnosisInvestmentStyleResultErrorProps> = ({
  onRetry,
}) => {
  const history = useHistory();

  return (
    <Box width="100%" maxWidth={608} p={3} display="flex" flexDirection="column" style={{ gap: 16 }}>
      <ErrorPanel
        description={
          <>
            結果の取得に失敗しました。
            <br />
            通信環境をご確認のうえ、再度お試しください。
          </>
        }
        retryLabel="再読み込み"
        onRetry={onRetry}
      />
      <CustomButton tone="outline" onClick={() => history.push("/mypage")}>
        マイページへ
      </CustomButton>
    </Box>
  );
};
